module.exports = __webpack_public_path__ + "img/service5.f0b7b3b2.png";